import React from 'react';
import { Field, ErrorMessage } from 'formik';

const InviteeDataStep = ({ inviteeData, isArabic, isSubmitting, setFieldValue, values }) => (
  <div className="flex flex-col items-center justify-center">
    <h3 className="text-lg font-medium mb-4">
      {inviteeData.inviteTitleAr}
    </h3>

    {/* Person Attendance */}
    <div className="mt-2">
      <label className="block text-sm text-center font-medium text-gray-700 mb-4">
        {inviteeData.name}
      </label>
      <div className="flex gap-4 ml-6 mb-2 text-sm md:text-lg">
        <label className="flex items-center gap-2">
          <Field type="radio" name="personComing" value="true" checked={values.personComing} onChange={() => setFieldValue('personComing', true)} className="form-radio text-blue-600" />
          <span>{isArabic ? 'يسعدني الحضور' : 'Joyfully accept'}</span>
        </label>
        <label className="flex items-center gap-2">
          <Field type="radio" name="personComing" value="false" checked={!values.personComing} onChange={() => setFieldValue('personComing', false)} className="form-radio text-blue-600" />
          <span>{isArabic ? 'أعتذر عن عدم الحضور' : 'Regretfully decline'}</span>
        </label>
      </div>
      <ErrorMessage name="personComing" component="div" className="text-red-500 text-sm" />
    </div>

    {/* Partner Attendance (if exists) */}
    {inviteeData.partnerName && (
      <div className="mt-4">
        <label className="block text-sm text-center font-medium text-gray-700 mb-2">
        {inviteeData.partnerName}
        </label>
        <div className="flex gap-4 ml-6 mb-2 text-sm md:text-lg">
          <label className="flex items-center gap-2">
            <Field type="radio" name="partnerComing" value="true" checked={values.partnerComing} onChange={() => setFieldValue('partnerComing', true)} className="form-radio text-blue-600" />
            <span>{isArabic ? 'يسعدني الحضور' : 'Joyfully accept'}</span>
          </label>
          <label className="flex items-center gap-2">
            <Field type="radio" name="partnerComing" value="false" checked={!values.partnerComing} onChange={() => setFieldValue('partnerComing', false)} className="form-radio text-blue-600" />
            <span>{isArabic ? 'أعتذر عن عدم الحضور' : 'Regretfully decline'}</span>
          </label>
        </div>
      </div>
    )}

    {/* Plus-Ones Counter */}
    {Object.keys(values.plusOnes).length > 0 && (
      <div className="mt-4 flex flex-col items-center">
        <label htmlFor="plusOneCount" className="block text-sm font-medium text-gray-700">
          {isArabic ? 'عدد الضيوف الإضافيين' : 'Number of Plus Ones'}:
        </label>
        <Field
          as="select"
          name="plusOneCount"
          id="plusOneCount"
          value={values.plusOneCount}
          onChange={(e) => {
            const selectedCount = parseInt(e.target.value, 10);
            setFieldValue('plusOneCount', selectedCount);
            Object.keys(values.plusOnes).forEach((key, index) => {
              setFieldValue(`plusOnes.${key}.status`, index < selectedCount ? 1 : 4);
            });
          }}
          className="mt-1 p-2 border border-gray-300 rounded-md"
        >
          {Array.from({ length: Object.keys(inviteeData.plusOnes || {}).length + 1 }, (_, i) => (
            <option key={i} value={i}>{i}</option>
          ))}
        </Field>
      </div>
    )}

    {/* Submit Button */}
    <div className="flex justify-between mt-4">
      <button type="submit" className="px-6 py-3 bg-text text-white rounded-md" disabled={isSubmitting}>
        {isSubmitting ? (isArabic ? 'جار التقديم...' : 'Submitting...') : (isArabic ? 'إرسال الرد' : 'Submit RSVP')}
      </button>
    </div>
  </div>
);

export default InviteeDataStep;
